import type { RootState } from '../store'
import { select, type SelectEffect } from 'redux-saga/effects'

/**
 * Helper wrapper function for redux-sage select calls that ensures the selector function has correct type.
 * @param selector
 */
export function selectFromState<T>(selector: (state: RootState) => T): SelectEffect {
  return select(selector)
}
